import { ReactElement } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import HouseIcon from '@mui/icons-material/House';
import ChurchIcon from '@mui/icons-material/Church';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import AlternateEmailIcon from '@mui/icons-material/AlternateEmail';

import { styled } from '@mui/material/styles';

import { useDialog } from '../contexts/dialog/hook';

declare const CONTACT_EMAIL_ADRESS: string;

const AddressDataContainer = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(3),
  padding: theme.spacing(1, 0),
  color: theme.palette.grey[700],
}));

export default function ContactDialog(): ReactElement {
  const { isOpen, close } = useDialog();

  return (
    <Dialog open={isOpen} onClose={close} maxWidth="xs">
      <DialogTitle color="secondary">Contact</DialogTitle>

      <DialogContent sx={{ color: ({ palette }) => palette.grey[600] }}>
        Als u nog vragen of opmerkingen heeft die niet beantwoord worden op deze site, schroom dan
        niet om contact met ons op te nemen.
        <Box mt={2}>
          <AddressDataContainer>
            <HouseIcon fontSize="large" />
            <Box>
              <Typography>Standerdmolen 20-1a</Typography>
              <Typography>3995 AA Houten</Typography>
            </Box>
          </AddressDataContainer>
          <AddressDataContainer>
            <ChurchIcon fontSize="large" />
            <Box>
              <Typography>Haagweg 1</Typography>
              <Typography>4814 GA Breda</Typography>
            </Box>
          </AddressDataContainer>
          <AddressDataContainer>
            <PhoneInTalkIcon fontSize="large" />
            <Typography
              component="a"
              href="tel:030-711-4704"
              sx={{ color: ({ palette }) => palette.secondary.main, textDecoration: 'none' }}
            >
              030 711 4704
            </Typography>
          </AddressDataContainer>
          <AddressDataContainer>
            <AlternateEmailIcon fontSize="large" />
            <Typography
              component="a"
              href={`mailto:${CONTACT_EMAIL_ADRESS}`}
              sx={{ color: ({ palette }) => palette.secondary.main, textDecoration: 'none' }}
            >
              {CONTACT_EMAIL_ADRESS}
            </Typography>
          </AddressDataContainer>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
